import moment from "moment";
import { Button } from "antd";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CustomIcon } from "datastake-daf/dist/components";
import Style from "./style";
import { logos } from "./config";
import { useFindInformation } from "../../../../store";

export default function EntityList({
  data: _data = [],
  filters = {},
  mod
}) {
  const { t } = useTranslation();
  const goTo = useNavigate();
  const { entities: { form } } = useFindInformation();

  const data = useMemo(() => _data.map((d) => {
    const item = d.items[0];
    const subCategory = item.datapoints.find((d) => d.dataId === 'subCategory')?.data;
    const category = item.datapoints.find((d) => d.dataId === 'category')?.data;
    const subCategoryOption = (form?.subCategory?.options || []).find((s) => s.value === category || s.value === subCategory);
    const subCategoryLabel = subCategoryOption?.label || subCategory;
    const categoryValue = ((subCategoryOption?.filters || [])[0]?.value || [])[0];

    return {
      id: item.datastakeId,
      category: categoryValue,
      subCategory: subCategoryLabel,
      name: item.name,
      origin: item.origin || '--',
      sources: d.items.length,
      lastUpdate: item.updatedAt,
    }
  }), [_data, form]);

  const items = data.filter((d) => {
    if (filters.search) {
      return d.name.toLowerCase().indexOf(filters.search.toLowerCase()) !== -1;
    }

    return !!d;
  });

  return (
    <Style>
      <div className="list">
        {items.map((entity) => (
          <div className="entity" key={entity.id}>
            <div className="entity-header">
              <CustomIcon name="Calendar" width={14} height={14} />
              <label className="ml-1">
                {moment(entity.lastUpdate).format('DD MMM YYYY')}
              </label>
            </div>

            <div className="entity-body">
              <div className="flex flex-column justify-content-center">
                <img src={logos[entity.category] || logos.individual} alt="img" />
              </div>

              <div className="flex flex-column justify-content-center info flex-1">
                <h2>{entity.name}</h2>
                <p>{entity.subCategory}</p>
              </div>

              <div className="flex flex-column justify-content-center">
                <Button
                  onClick={() => {
                    goTo(`/app/${mod}/find-information/${entity.id}`);
                  }}
                  icon={<CustomIcon name="View" width={12} height={12} />}
                />
              </div>
            </div>

            <div className="entity-footer">
              <div className="footer-row">
                <label>{t('Source(s)')}</label>
                <label className="value">{Number(entity.sources || 0).toLocaleString('en-us')}</label>
              </div>

              <div className="footer-row">
                <label>{t('Origin')}</label>
                <label className="value">{entity.origin}</label>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Style>
  )
}
